// @flow
import { connect } from 'react-redux';

import { fetchTagArticle } from 'actions/tagArticleActions';
import { fetchGenericSidebar } from 'actions/sidebarActions';

import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/tagarticle/TagArticle';
import TagArticle from 'components/tagarticle/TagArticle';

export default connect(
  (state: StateType): StateProps => ({
    tagArticles: state.tagArticleState.tagArticles,
    tagArticleNumber: state.tagArticleState.tagArticleNumber,
    tag: state.tagArticleState.tag,
    status: state.tagArticleState.status,
    sidebar: state.sidebarState,
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchTagArticle: (slug: string, page: number, per_page: number) => 
      dispatch(fetchTagArticle(slug, page, per_page)),
    fetchGenericSidebar: () => dispatch(fetchGenericSidebar())
  })
)(TagArticle);